import React, { PropsWithChildren } from 'react';
import { AlertType } from '@lib/alertContext';
import { ErrorAlert, InfoAlert, SuccessAlert } from '@lifechurch/react-ion';

interface BannerProps {
  uniqueKey: string;
  type: AlertType;
  onDismiss?: () => void;
  fuseDisabled?: boolean;
  fuseTimer?: number;
}

const Alert: React.FC<PropsWithChildren<BannerProps>> = ({
  children,
  fuseDisabled,
  fuseTimer,
  onDismiss,
  type,
  uniqueKey,
}) => {
  switch (type) {
    case AlertType.INFO:
      return (
        <InfoAlert
          fuseDisabled={fuseDisabled}
          fuseTimer={fuseTimer}
          onDismiss={onDismiss}
          uniqueKey={uniqueKey}
        >
          {children}
        </InfoAlert>
      );
    case AlertType.SUCCESS:
      return (
        <SuccessAlert
          fuseDisabled={fuseDisabled}
          fuseTimer={fuseTimer}
          onDismiss={onDismiss}
          uniqueKey={uniqueKey}
        >
          {children}
        </SuccessAlert>
      );
    case AlertType.ERROR:
      return (
        <ErrorAlert
          fuseDisabled={fuseDisabled}
          fuseTimer={fuseTimer}
          onDismiss={onDismiss}
          uniqueKey={uniqueKey}
        >
          {children}
        </ErrorAlert>
      );
    default:
      return null;
  }
};

export default Alert;
